import MaintainerLoginCom from "../../components/admin/login/MaintainerLoginCom";

const MaintainerLogin = () => {
  return (
    <>
      <MaintainerLoginCom />
    </>
  );
};

export default MaintainerLogin;
